var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-feed"},[(_vm.socialFeed === 'Facebook')?_c('FaceBook'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }